import Phaser from 'phaser';

// Visual hit effect — pooled in scene to avoid GC churn (PRD 2.5)
export function spawnHitFx(scene: Phaser.Scene, x: number, y: number, opts: { damage: number; crit?: boolean } = { damage: 0 }) {
  const sprite = scene.add.sprite(x, y, 'fx_hit').setScale(0.5).setDepth(20);
  scene.tweens.add({
    targets: sprite, scale: { from: 0.5, to: 1.4 }, alpha: { from: 1, to: 0 },
    duration: 280, onComplete: () => sprite.destroy(),
  });
  if (opts.damage > 0) {
    const color = opts.crit ? '#ffd166' : '#ffffff';
    const fontSize = opts.crit ? '22px' : '16px';
    const label = scene.add.text(x, y - 10, opts.crit ? `${opts.damage}!` : `${opts.damage}`, {
      fontFamily: '"Philosopher", "Marcellus SC", Impact, serif', fontSize, color, stroke: '#000', strokeThickness: 4,
    }).setOrigin(0.5).setDepth(21);
    scene.tweens.add({
      targets: label, y: y - 50, alpha: { from: 1, to: 0 },
      duration: 700, onComplete: () => label.destroy(),
    });
  }
}
